/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PatientReassignmentTable.vue?vue&type=template&id=61e31713&scoped=true"
import script from "./PatientReassignmentTable.vue?vue&type=script&lang=js"
export * from "./PatientReassignmentTable.vue?vue&type=script&lang=js"
import style0 from "./PatientReassignmentTable.vue?vue&type=style&index=0&id=61e31713&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e31713",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e31713')) {
      api.createRecord('61e31713', component.options)
    } else {
      api.reload('61e31713', component.options)
    }
    module.hot.accept("./PatientReassignmentTable.vue?vue&type=template&id=61e31713&scoped=true", function () {
      api.rerender('61e31713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/PatientReassignmentTable.vue"
export default component.exports